// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/react-image-gallery/styles/css/image-gallery.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/react-phone-number-input/style.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Photo1.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/Photo2.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/photo3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/spa.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/balcon-mandarine.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/resto.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/kaak-warka-patisserie.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Aqua Grotesque', serif;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
	width:100%;
	position:absolute;

}

input {
	border: 1px solid green;
}

.has-error input[type="text"], .has-error input[type="email"], .has-error input {
    border: 1px solid #a94442;
}

::-webkit-scrollbar {
	width: 13px;
}

::-webkit-scrollbar-track {
	background: #fff;
}

::-webkit-scrollbar-thumb {
	background: #03AC13;
}

span{
	text-transform:none;
}
p {
	margin-bottom: 0px;
	font-size: 14px;
	color: #666666;
	line-height: 30px;
}
a {
	text-transform : 'lowercase';
}
ul {
	padding: 0;
	margin: 0;
	list-style: none;
}

h1,h2,h3,h4,h5,h6 {
	margin: 0px;
}

.last:last-child{
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
	justify-items: center;
	justify-self: center;
	text-align: center;
	align-content: center;
}

/*Link Activities*/

.filled-btn-acti{
	border: 1px solid #03AC13;
	color: #03AC13;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	background-color: transparent;
}

.filled-btn-acti:hover {
	background-color: #03AC13;
	border: 1px solid #03AC13;
	color:#fff;
}
/*Link On Hover*/
.filled-btn{
	border: 1px solid #03AC13;
	color: #fff;
	font-size: 13px;
	text-transform: capitalize;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	background-color: #03AC13;
}



.filled-btn:hover {
	background-color: transparent;
	border: 1px solid #03AC13;
}

.filled-btn-avis{
	border: 1px solid #03AC13;
	color: #fff;
	font-size: 13px;
	text-transform: none;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	background-color: #03AC13;
}

.filled-btn-avis:hover {
	background-color: transparent;
	border: 1px solid #03AC13;
	color:#03AC13;
}

.filled-btn-scroll{
	border: 3px solid #fff;
	color: white;
	font-size: 13px;
	text-transform: capitalize;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	background-color: transparent;
}

.filled-btn-scroll:hover {
	background-color: #03AC13;
	border: 1px solid #03AC13;
	color:white;
}


.filled-btn-visite{
	border: 1px solid #fff;
	color: #03AC13;
	font-size: 12px;
	text-transform: capitalize;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	background-color: #fff;
}

.filled-btn-visite:hover {
	background-color: transparent;
	border: 1px solid #03AC13;
	color:#fff;
}

/*Consulter menu*/

.filled-btn-reverse{
	border: 1px solid #fff;
	color: #fff;
	font-size: 13px;
	text-transform: capitalize;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	background-color: transparent;
}

.filled-btn-reverse:hover {
	background-color: transparent;
	border: 1px solid #03AC13;

}


a.filled-button {
	background-color: #03AC13;
	color: #fff;
	font-size: 16px;
	text-transform: capitalize;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 1s;
}

a.filled-button:hover {
	background-color: transparent;
	color: #03AC13;
	border: 1px solid #03AC13;
}

a.border-button {
	background-color: transparent;
	color: #fff;
	border: 2px solid #fff;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 10px 28px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
}

/*Pack Button*/


.filled-btn-pack{
	border: 1px solid #03AC13;
	color: #fff;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	background-color: #03AC13;
}

.filled-btn-pack:hover {
	background-color: transparent;
	border: 1px solid #fff;
}


a.filled-btn-pack {
	background-color: #03AC13;
	
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
}

a.filled-btn-pack:hover {
	border: 1px solid #03AC13;
}

a.border-btn-pack {
	background-color: transparent;
	color: #fff;
	border: 2px solid #fff;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 10px 28px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
}



/*Badge*/
.price-badge {
	position: absolute;
	top: 0;
	z-index: 999;
	right: 0;
	width: 100%;
	display: block;
	font-size: 15px;
	padding: 0;
	overflow: hidden;
	height: 100px;
  }
  
  .price-badge .badge {
	float: right;
	transform: rotate(45deg);
	right: -67px;
	top: 17px;
	position: relative;
	text-align: center;
	width: 200px;
	font-size: 13px;
	margin: 0;
	padding: 7px 10px;
	font-weight: 500;
	color: #ffffff;
	background: #03AC13;
  }

a.border-button:hover {
	background-color: #fff;
	color: #03AC13;
}

.section-heading {
	text-align: center;
	margin-bottom: 80px;
}

.section-heading h2 {
	font-size: 36px;
	font-weight: 600;
	color: #1e1e1e;
}

.section-heading em {
	font-style: normal;
	color: #03AC13;
}

.section-heading span {
	display: block;
	margin-top: 15px;
	text-transform: uppercase;
	font-size: 15px;
	color: #666;
	letter-spacing: 1px;
}

#preloader {
  overflow: hidden;
  background: #ffffff;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  z-index: 9999999;
  color: #fff;
}

#preloader .jumper {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: block;
  position: absolute;
  margin: auto;
  width: 50px;
  height: 50px;
}

#preloader .jumper > div {
  background-color: #fff;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  animation-fill-mode: both;
  position: absolute;
  opacity: 0;
  width: 50px;
  height: 50px;
  animation: jumper 1s 0s linear infinite;
}

#preloader .jumper > div:nth-child(2) {
  animation-delay: 0.33333s;
}

#preloader .jumper > div:nth-child(3) {
  animation-delay: 0.66666s;
}

@keyframes jumper {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  5% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* Sub Header Style */

.sub-header {
	background-color: #03AC13;
	height: 46px;
	position:relative;
	line-height: 46px;
}

.sub-header ul li {
	display: inline-block;
}

.sub-header ul.left-info li {
	border-left: 1px solid rgba(250,250,250,0.3);
	padding: 0px 20px;
}

.sub-header ul.left-info  {
	border-right: 1px solid rgba(250,250,250,0.3);
	width: max-content;
}

.sub-header ul.left-info li i {
	margin-right: 10px;
	font-size: 18px;
}

.sub-header ul.left-info li a {
	color: #fff;
	font-size: 14px;
	font-weight: 600;
}

.sub-header ul.right-icons {
	float: right;
}

.sub-header ul.right-icons li {
	margin-right: -4px;
	width: 46px;
	display: inline-block;
	text-align: center;
	border-right: 1px solid rgba(250,250,250,0.3);
}

.sub-header ul.right-icons li:first-child {
	border-left: 1px solid rgba(250,250,250,0.3);
}

.sub-header ul.right-icons li a {
	color: #fff;
	transition: all 0.3s;
}

.sub-header ul.right-icons li a:hover {
	opacity: 0.75;
}



/* Header Style */
header {
	position: absolute;
	z-index: 99999;
	width: 100%;
	background-color: transparent!important;
	height: 80px;
 transition: all 0.3s ease-in-out 0s;
}
header .navbar {
	padding: 20px 0px;
}
.background-header .navbar {
	padding: 10px 0px;
}
.background-header {
	top: 0;
	position: fixed;
	height:100px;
	background-color: #fff!important;
	box-shadow: 0px 1px 10px rgba(0,0,0,0.1);
}
.background-header .navbar-brand {
	color: #028A0F!important;
}
.background-header .navbar-nav a.nav-link {
	color: #1e1e1e!important;
}
.background-header .navbar-nav .nav-link:hover,
.background-header .navbar-nav .active>.nav-link,
.background-header .navbar-nav .nav-link.active,
.background-header .navbar-nav .nav-link.show,
.background-header .navbar-nav .show>.nav-link {
	color: #03AC13!important;
}
.navbar .navbar-brand {
	float: 	left;
	outline: none;
	position:relative;

}
.navbar .navbar-brand h2 {
	color: #fff;
	text-transform: uppercase;
 transition: all .3s ease 0s;
}
.navbar .navbar-brand h2 em {
	font-style: normal;
	font-size: 16px;
}
#navbarResponsive {
	z-index: 999;
}
.navbar-collapse {
	text-align: center;
}
.navbar .navbar-nav .nav-item {
	margin: 0px 8px;
}
.navbar .navbar-nav a.nav-link {
	text-transform: capitalize;
	font-size: 15px;
	font-weight: 300;
	letter-spacing: 0.5px;
	color: #fff;
	transition: all 0.5s;
	margin-top: 5px;
}
.navbar .navbar-nav .nav-link:hover,
.navbar .navbar-nav .active>.nav-link,
.navbar .navbar-nav .nav-link.active,
.navbar .navbar-nav .nav-link.show,
.navbar .navbar-nav .show>.nav-link {
	color: #03AC13;
	border-bottom: 3px solid #a4c639;
}
.navbar .navbar-toggler-icon {
	background-image: none;
}
.navbar .navbar-toggler {
	opacity: 0.5;
	outline: none;
	position: absolute;
	right: 30px;
	top: 30px;
}
.navbar .navbar-toggler-icon:after {
	content: '\\f0c9';
	color: #03AC13;
	font-size: 18px;
	line-height: 26px;
	font-family: 'FontAwesome';
}


/* Banner Style */

.img-fill{
  width: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  text-align: center
}
.img-fill:before {
	content: '';
	z-index: 1;
	position: absolute;
	top: 0;
	left: 0;
	bottom:0;
	right: 0;
	background-color: rgba(0,0,0,.6)
}
.Modern-Slider .text-content{
	z-index: 2;
}

.img-fill img {
  min-height: 100%;
  min-width: 100%;
  position: relative;
  display: inline-block;
  max-width: none;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.Grid1k {
  padding: 0 15px;
  max-width: 1200px;
  margin: auto;
}

.blocks-box,
.slick-slider {
  margin: 0;
  padding: 0!important;
}

.slick-slide {
  float: left;
  padding: 0;
}

.Modern-Slider .item .img-fill {
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	height:95vh;
}

.Modern-Slider .item-1 .img-fill {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.Modern-Slider .item-2 .img-fill {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.Modern-Slider .item-3 .img-fill {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.Modern-Slider .NextArrow{
  position:absolute;
  top:50%;
  right:30px;
  border:0 none;
  background-color: transparent;
  text-align:center;
  font-size: 36px;
  font-family: 'FontAwesome';
  color:#FFF;
  z-index:5;
  outline: none;
  cursor: pointer;
}

.Modern-Slider .NextArrow:before{
  content:'\\f105';
}

.Modern-Slider .PrevArrow {
  position:absolute;
  top:50%;
  left:30px;
  border:0 none;
  background-color: transparent;
  text-align:center;
  font-size: 36px;
  font-family: 'FontAwesome';
  color:#FFF;
  z-index:5;
  outline: none;
  cursor: pointer;
}

.Modern-Slider .PrevArrow:before{
  content:'\\f104';
}

ul.slick-dots {
  display: none!important;
}


.Modern-Slider .item h6 {
  margin-bottom: 15px;
  font-size: 22px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  color:#03AC13;
  animation:fadeOutRight 1s both;
}

.Modern-Slider .item h4 {
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 44px;
  font-weight: 700;
  letter-spacing: 2.5px;
  color:#FFF;
  overflow:hidden;
  animation:fadeOutLeft 1s both;
}

.Modern-Slider .item p {
	max-width: 570px;
	color: #fff;
	font-size: 15px;
	font-weight: 400;
	line-height: 30px;
	margin-bottom: 40px;
}

.Modern-Slider .item a {
  margin: 0 5px;
}

.Modern-Slider .item.slick-active h6{
  animation:fadeInDown 1s both 1s;
}

.Modern-Slider .item.slick-active h4{
  animation:fadeInLeft 1s both 1.5s;
}

.Modern-Slider .item.slick-active{
  animation:Slick-FastSwipeIn 1s both;
}

.Modern-Slider .buttons {
  position: relative;
}

.Modern-Slider {background:#000;}


/* ==== Slick Slider Css Ruls === */
.slick-slider{position:relative;display:block;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;touch-action:pan-y;-webkit-tap-highlight-color:transparent}
.slick-list{position:relative;display:block;overflow:hidden;margin:0;padding:0}
.slick-list:focus{outline:none}.slick-list.dragging{cursor:hand}
.slick-slider .slick-track,.slick-slider .slick-list{transform:translate3d(0,0,0)}
.slick-track{position:relative;top:0;left:0;display:block}
.slick-track:before,.slick-track:after{display:table;content:''}.slick-track:after{clear:both}
.slick-loading .slick-track{visibility:hidden}
.slick-slide{display:none;float:left /* If RTL Make This Right */ ;height:100%;min-height:1px}
.slick-slide.dragging img{pointer-events:none}
.slick-initialized .slick-slide{display:block}
.slick-loading .slick-slide{visibility:hidden}
.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}




/* Request Form */

.request-form {
	background-color: #03AC13;
	color: #fff;
}

.request-form h4 {
	font-size: 22px;
	font-weight: 600;
}

.request-form span {
	font-size: 15px;
	font-weight: 400;
	display: inline-block;
	margin-top: 10px;
}

.request-form a.border-button {
	margin-top: 12px;
	float: right;
}




/* Services */

.services {
	margin-top: 140px;
}

.service-item img {
	width: 100%;
	overflow: hidden;
}

.service-item .down-content {
	background-color: #f7f7f7;
	padding: 30px;
}

.service-item .down-content h4 {
	font-size: 20px;
	font-weight: 700;
	letter-spacing: 0.25px;
	margin-bottom: 15px;
}

.service-item .down-content p {
	margin-bottom: 20px;
}

.page-link:hover,
.page-link {
	color: #03AC13;
}

.btn-primary {
	border-color: #03AC13;
	background-color: #03AC13;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary:active:focus{
	opacity: 0.6;
	border-color: #a4c639;
	background-color: #a4c639;
}


/* Fun Facts */

.fun-facts {
	margin-top: 140px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	background-attachment: fixed;
	color: #fff;
	position: relative;
}

.fun-facts .container {
	position: relative;
	z-index: 2;
}

.fun-facts:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 1;
}

.fun-facts span {
	text-transform: uppercase;
	font-size: 15px;
	color: #fff;
	letter-spacing: 1px;
	margin-bottom: 10px;
	display: block;
}

.fun-facts h2 {
	font-size: 36px;
	font-weight: 600;
	margin-bottom: 35px;
}

.fun-facts em {
	font-style: normal;
	color: #a4c639;
}

.fun-facts p {
	color: #fff;
	margin-bottom: 40px;
}

.fun-facts .left-content {
	margin-right: 45px;
}

.count-area-content {
	text-align: center;
	background-color: rgba(250,250,250,0.1);
	padding: 25px 30px 35px 30px;
	margin: 15px 0px;
}

.count-digit {
    margin: 5px 0px;
    color: #a4c639;
    font-weight: 700;
    font-size: 36px;
}
.count-title {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.5px;
}



/* More Info */

.more-info {
	margin-top: 140px;
}

.more-info .left-image img {
	width: 100%;
	overflow: hidden;
}

.more-info .more-info-content {
	background-color: #f7f7f7;
}

.about-info .more-info-content {
	background-color: transparent;
}

.about-info .right-content {
	padding: 0px!important;
	margin-right: 30px;
}

.more-info .right-content {
	padding: 45px 45px 45px 30px;
}

.more-info .right-content span {
	text-transform: uppercase;
	font-size: 15px;
	color: #666;
	letter-spacing: 1px;
	margin-bottom: 10px;
	display: block;
}

.more-info .right-content h2 {
	font-size: 36px;
	font-weight: 600;
	margin-bottom: 35px;
}

.more-info .right-content em {
	font-style: normal;
	color: #03AC13;
}

.more-info .right-content p {
	margin-bottom: 30px;
}


/* Testimonials Style */


.about-testimonials {
	margin-top: 0px!important;
}

.testimonials {
	margin-top: 50px;
	background-color: #ffffff;
	padding: 140px 0px;
}
.testimonial-item .inner-content {
	text-align: center;
	background-color: #fff;	
	padding: 30px;
	border-radius: 5px;
}
.testimonial-item p {
	font-size: 14px;
	font-weight: 400;
}
.testimonial-item h4 {
	font-size: 19px;
	font-weight: 700;
	color: #1e1e1e;
	letter-spacing: 0.5px;
	margin-bottom: 0px;
}
.testimonial-item span {
	display: inline-block;
	margin-top: 8px;
	font-weight: 600;
	font-size: 14px;
	color: #03AC13;
}
.testimonial-item img {
	max-width: 60px;
	border-radius: 50%;
	margin: 25px auto 0px auto;
}

/* Call Back Style */

.callback-services {
	border-top: 1px solid #eee;
	padding-top: 140px;
}

.contact-us {
	background-color: #f7f7f7;
	padding: 140px 0px;
}

.contact-us .contact-form {
	background-color: transparent!important;
	padding: 0!important;
}

.callback-form {
	margin-top: -50px;
}

.callback-form .contact-form {
	background-color: #00933F;
	padding: 60px;
	border-radius: 15px;
	text-align: center;
}

.callback-form .contact-form input {
	border-radius: 20px;
	height: 40px;
	line-height: 40px;
	display: inline-block;
	padding: 0px 15px;
	color: #6a6a6a;
	font-size: 13px;
	text-transform: none;
	box-shadow: none;
	border: none;
	margin-bottom: 35px;
}

.callback-form .contact-form input:focus {
	outline: none;
	box-shadow: none;
	border: none;
}

.callback-form .contact-form textarea {
	border-radius: 20px;
	height: 120px;
	max-height: 200px;
	min-height: 120px;
	display: inline-block;
	padding: 15px;
	color: #6a6a6a;
	font-size: 13px;
	text-transform: none;
	box-shadow: none;
	border: none;
	margin-bottom: 35px;
}

.callback-form .contact-form textarea:focus {
	outline: none;
	box-shadow: none;
	border: none;
}
.callback-form .contact-form ::placeholder {
  color: #aaa;
}

.callback-form .contact-form button.border-button {
	background-color: transparent;
	color: #fff;
	border: 2px solid #fff;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 10px 28px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	outline: none;
	box-shadow: none;
	text-shadow: none;
	cursor: pointer;
}

.callback-form .contact-form button.border-button:hover {
	background-color: #fff;
	color: #00933F;
}

.contact-us .contact-form button.filled-button {
	background-color: #00933F;
	color: #fff;
	border: none;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	outline: none;
	box-shadow: none;
	text-shadow: none;
	cursor: pointer;
}

.contact-us .contact-form button.filled-button:hover {
	background-color: #fff;
	color: #00933F;
}

.filled-button {
	background-color: #00933F;
	color: #fff;
	border: none;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	outline: none;
	box-shadow: none;
	text-shadow: none;
	cursor: pointer;
}

.filled-button:hover {
	background-color: #fff;
	color: #00933F;
}



/* Partners Style */

.contact-partners {
	margin-top: -8px!important;
}

.partners {
	margin-top: 140px;
	background-color: #f7f7f7;
	padding: 60px 0px;
}

.partners .owl-item {
	text-align: center;
	cursor: pointer;
}

.partners .partner-item img {
	max-width: 156px;
	margin: auto;
}



/* Footer Style */

footer {
	background-color: #232323;
	padding: 80px 0px;
	color: #fff;
}

footer h4 {
	color: #fff;
	font-size: 20px;
	font-weight: 600;
	letter-spacing: 0.25px;
	margin-bottom: 35px;
}
footer p {
	color: #fff;
}

footer ul.social-icons {
	margin-top: 25px;
}

footer ul.social-icons li {
	display: inline-block;
	margin-right: 5px;
}

footer ul.social-icons li:last-child {
	margin-right: 0px;
}
/*Contact icons*/

footer .contact-icons {
	width: 34px;
	height: 34px;
	display: inline-block;
	line-height: 34px;
	text-align: center;
	background-color: #fff;
	color: #232323;
	border-radius: 50%;
	transition: all 0.3s;
}

footer .contact-icons:hover {
	background-color: #03AC13;
	color: white;
}

footer ul.social-icons li a {
	width: 34px;
	height: 34px;
	display: inline-block;
	line-height: 34px;
	text-align: center;
	background-color: #fff;
	color: #232323;
	border-radius: 50%;
	transition: all 0.3s;
}

footer ul.social-icons li a:hover {
	background-color: #03AC13;
	color: white;
}

footer ul.menu-list li {
	margin-bottom: 13px;
}

footer ul.menu-list li:last-child {
	margin-bottom: 0px;
}

footer ul.menu-list li a {
	font-size: 14px;
	color: #fff;
	transition: all 0.3s;
}

footer ul.menu-list li a:hover {
	color: #03AC13;
}

footer .contact-form input {
	border-radius: 20px;
	height: 40px;
	line-height: 40px;
	display: inline-block;
	padding: 0px 15px;
	color: #aaa!important;
	background-color: #343434;
	font-size: 13px;
	text-transform: none;
	box-shadow: none;
	border: none;
	margin-bottom: 15px;
}

footer .contact-form input:focus {
	outline: none;
	box-shadow: none;
	border: none;
	background-color: #343434;
}

footer .contact-form textarea {
	border-radius: 20px;
	height: 120px;
	max-height: 200px;
	min-height: 120px;
	display: inline-block;
	padding: 15px;
	color: #aaa!important;
	background-color: #343434;
	font-size: 13px;
	text-transform: none;
	box-shadow: none;
	border: none;
	margin-bottom: 15px;
}

footer .contact-form textarea:focus {
	outline: none;
	box-shadow: none;
	border: none;
	background-color: #343434;
}
footer .contact-form ::placeholder {
  color: #aaa;
}

footer .contact-form button.filled-button {
	background-color: transparent;
	color: #fff;
	background-color: #03AC13;
	border: none;
	font-size: 13px;
	text-transform: uppercase;
	font-weight: 700;
	padding: 12px 30px;
	border-radius: 30px;
	display: inline-block;
	transition: all 0.3s;
	outline: none;
	box-shadow: none;
	text-shadow: none;
	cursor: pointer;
}

footer .contact-form button.filled-button:hover {
	background-color: #fff;
	color: #597D35;
}



/* Sub-footer Style */

.sub-footer {
	background-color: #343434;
	text-align: center;
	padding: 25px 0px;
}

.sub-footer p {
	color: #fff;
	font-weight: 300;
	letter-spacing: 0.5px;
}

.sub-footer a {
	color: #fff;
}


.page-heading {
	text-align: center;
	min-height: 100vh;
	/*background-image: url(../images/background.jpg);*/
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 230px 0px 150px 0px;
	color: #fff;
	position: relative;
		height:680px;

}
.page-heading .container {
	position: relative;
	z-index: 2;
}

.page-heading:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 1;
	height:auto;
}

.page-heading h1 {
	text-transform: capitalize;
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 2px;
	margin-bottom: 18px;
}

.page-heading span {
	font-size: 15px;
	text-transform: uppercase;
	letter-spacing: 1px;
	color: #fff;
	display: block;
}
/*Spa Heading*/
.page-heading-spa {
	text-align: center;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 230px 0px 150px 0px;
	color: #fff;
	position: relative;
}
.page-heading-spa .container {
	position: relative;
	z-index: 2;
}

.page-heading-spa:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 1;
	
}

.page-heading-spa h1 {
	text-transform: capitalize;
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 2px;
	margin-bottom: 18px;
}

.page-heading-spa span {
	font-size: 15px;
	text-transform: uppercase;
	letter-spacing: 1px;
	color: #fff;
	display: block;
}
/*Activities Heading*/
.page-heading-activities {
	text-align: center;
	/*background-image: url(../images/background.jpg);*/
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 230px 0px 150px 0px;
	color: #fff;
	position: relative;
}
.page-heading-activities .container {
	position: relative;
	z-index: 2;
}

.page-heading-activities:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 1;
}

.page-heading-activities h1 {
	text-transform: capitalize;
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 2px;
	margin-bottom: 18px;
}

.page-heading-activities span {
	font-size: 15px;
	text-transform: uppercase;
	letter-spacing: 1px;
	color: #fff;
	display: block;
}

/*Rooms Heading*/

.page-heading-rooms {
	text-align: center;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 230px 0px 150px 0px;
	color: #fff;
	position: relative;
}
.page-heading-rooms .container {
	position: relative;
	z-index: 2;
}

.page-heading-rooms:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 1;
}

.page-heading-rooms h1 {
	text-transform: capitalize;
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 2px;
	margin-bottom: 18px;
}

.page-heading-rooms span {
	font-size: 15px;
	text-transform: uppercase;
	letter-spacing: 1px;
	color: #fff;
	display: block;
}


/*Restaurant Heading*/

.page-heading-rest {
	text-align: center;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 230px 0px 150px 0px;
	color: #fff;
	position: relative;
}
.page-heading-rest .container {
	position: relative;
	z-index: 2;
}

.page-heading-rest:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 1;
}

.page-heading-rest h1 {
	text-transform: capitalize;
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 2px;
	margin-bottom: 18px;
}

.page-heading-rest span {
	font-size: 15px;
	text-transform: uppercase;
	letter-spacing: 1px;
	color: #fff;
	display: block;
}

/*Products Heading*/
.page-heading-product {
	text-align: center;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	padding: 230px 0px 150px 0px;
	color: #fff;
	position: relative;
}
.page-heading-product .container {
	position: relative;
	z-index: 2;
}

.page-heading-product:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0,0,0,0.5);
	z-index: 1;
}

.page-heading-product h1 {
	text-transform: capitalize;
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 2px;
	margin-bottom: 18px;
}

.page-heading-product span {
	font-size: 15px;
	text-transform: uppercase;
	letter-spacing: 1px;
	color: #fff;
	display: block;
}

/*Effect Hover Image*/
.hover03 .figure .img-petit-dej {
	height: auto;
	transition: .3s ease-in-out;
}
.hover03 .figure:hover .img-petit-dej {
	width: 530px;
	border-bottom-left-radius: 35px;
	border-top-right-radius: 35px;
	
}

/*Center Div*/

.center-div {
	margin: 0 auto;
	width: 100%;
	justify-content: center;
}

/* team */

.team {
	background-color: #f7f7f7;
	margin-top: 140px;
	margin-bottom: -140px;
	padding: 120px 0px;
}

.team-item img {
	width: 100%;
	overflow: hidden;
}

.team-item .down-content {
	background-color: #fff;
	padding: 30px;
}

.team-item .down-content h4 {
	font-size: 20px;
	font-weight: 700;
	letter-spacing: 0.25px;
	margin-bottom: 10px;
}

.team-item .down-content span {
	color: #03AC13;
	font-weight: 600;
	font-size: 14px;
	display: block;
	margin-bottom: 15px;
}

.team-item .down-content p {
	margin-bottom: 20px;
}


/* Single Service */

.single-services {
	margin-top: 140px;
}

#tabs ul {
  margin: 0;
  padding: 0;
}
#tabs ul li {
  margin-bottom: 10px;
  display: inline-block;
  width: 100%;
}
#tabs ul li:last-child {
  margin-bottom: 0px;
}
#tabs ul li a {
	text-transform: capitalize;
	width: 100%;
	padding: 20px;
	display: inline-block;
	background-color: #1c7430;
	border-radius: 25px;
  	font-size: 18px;
  	color: #121212;
  	letter-spacing: 0.5px;
  	font-weight: 700;
  	transition: all 0.3s;
}
#tabs ul li a i {
	float: right;
	margin-top: 5px;
}
#tabs ul .ui-tabs-active span {
  background: #03AC13;
  border: #faf5b2;
  line-height: 90px;
  border-bottom: none;
}
#tabs ul .ui-tabs-active a {
  color: #fff;
}
#tabs ul .ui-tabs-active span {
  color: #1e1e1e;
}
.tabs-content {
	margin-left: 30px;
  text-align: left;
  display: inline-block;
  transition: all 0.3s;
}
.tabs-content img {
	max-width: 100%;
	overflow: hidden;
}
.tabs-content h4 {
	font-size: 20px;
	font-weight: 700;
	letter-spacing: 0.25px;
	margin-bottom: 15px;
	margin-top: 30px;
}
.tabs-content h4 a {
	color: inherit;	
}
.tabs-content p {
  font-size: 14px;
  color: #7a7a7a;
  margin-bottom: 0px;
}

.dropdown-item.active, 
.dropdown-item:active {
	background-color: #a4c639;
}

/* Contact Information */

.contact-information {
	margin-top: 140px;
}

.contact-information .contact-item {
	padding: 60px 30px;
	background-color: #f7f7f7;
	text-align: center;
}

.contact-information .contact-item i {
	color: #03AC13;
	font-size: 48px;
	margin-bottom: 40px;
}

.contact-information .contact-item h4 {
	font-size: 20px;
	font-weight: 700;
	letter-spacing: 0.25px;
	margin-bottom: 15px;
}

.contact-information .contact-item p {
	margin-bottom: 20px;
}

.contact-information .contact-item a {
	font-weight: 600;
	color: #1c7430;
	font-size: 15px;
}



#offers {
  padding-top: 120px;
}

#offers .section-heading {
  margin-bottom: 70px;
}

#offers .section-heading h6 {
  padding-left: 0px;
}

#offers .section-heading h6:before {
  display: none;
}

#offers .heading-tabs {
  text-align: center;
}

#offers .heading-tabs .main-dark-button {
  text-align: right;
}

#offers #tabs ul {
  padding: 0;
}
#offers #tabs ul li {
  display: inline-block;
  margin: 0px 15px;
}
#offers #tabs ul li:last-child {
  margin-right: 0px;
}
#offers #tabs ul li:first-child {
  margin-left: 0px;
}
#offers #tabs ul li a {
  text-transform: capitalize;
  width: 100%;
  display: inline-block;
  font-size: 15px;
  color: #2a2a2a;
  font-weight: 600;
  transition: all 0.3s;
  text-align: center;
}

#offers #tabs ul li a img {
  display: block;
  margin: 0 auto 15px auto;
}
#offers #tabs ul .ui-tabs-active a {
  color: #fb5849;
  position: relative;
}
#offers #tabs ul .ui-tabs-active span {
  color: #1e1e1e;
}
#offers .tabs-content {
  margin-top: 60px;
  text-align: left;
  display: inline-block;
  transition: all 0.3s;
}
#offers .tabs-content .tab-item {
  position: relative;
  margin-bottom: 60px;
}
#offers .tabs-content img {
  float: left;
  width: 100px;
  max-width: 100px;
  margin-right: 20px;
  border-radius: 5px;
}
#offers .tabs-content h4 {
  padding-top: 10px;
  font-size: 20px;
  font-weight: 700;
  color: #2a2a2a;
  margin-bottom: 10px;
  margin-right: 100px;
}

#offers .tabs-content p {
  margin-right: 100px;
}

#offers .tabs-content .left-list {
  margin-right: 15px;
}

#offers .tabs-content .right-list {
  margin-left: 15px;
}

#offers .tabs-content .price h6 {
  position: absolute;
  top: 15px;
  right: 0;
  width: 70px;
  height: 70px;
  background-color: #fb5849;
  display: inline-block;
  text-align: center;
  line-height: 70px;
  border-radius: 3px;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}





/* Responsive Style */
@media (max-width: 768px) {
	.sub-header {
		display: none;
	}
	.Modern-Slider .item h6 {
	  margin-bottom: 15px;
	  font-size: 18px;
	}
	.Modern-Slider .item h4 {
	  margin-bottom: 25px;
	  font-size: 28px;
	  line-height: 36px;
	  letter-spacing: 1px;
	}
	.Modern-Slider .item p {
		max-width: 570px;
		line-height: 25px;
		margin-bottom: 30px;
	}
	.Modern-Slider .NextArrow{
	  right:5px;
	}
	.Modern-Slider .PrevArrow {
	  left:5px;
	}
	.request-form {
		text-align: center;
	}
	.request-form a.border-button {
		float: none;
		margin-top: 30px;
	}
	.services .service-item {
		margin-bottom: 30px;
	}
	.fun-facts .left-content {
		margin-right: 0px;
		margin-bottom: 30px;
	}
	.more-info .right-content  {
		padding: 30px;
	}
	footer {
		padding: 80px 0px 20px 0px;

	}
	footer .footer-item {
		border-bottom: 1px solid #343434;
		margin-bottom: 30px;
		padding-bottom: 30px;
	}
	footer .last-item {
		border-bottom: none;
	}
	.about-info .right-content {
		margin-right: 0px;
		margin-bottom: 30px;
	}
	.team .team-item {
		margin-bottom: 30px;
	}
	.tabs-content {
		margin-left: 0px;
		margin-top: 30px;
	}
	.contact-item {
		margin-bottom: 30px;
	}

	.filled-button2 {
		background-color: #00933F;
		color: #fff;
		border: none;
		font-size: 8px;
		text-transform: uppercase;
		font-weight: 700;
		border-radius: 30px;
		display: inline-block;
		transition: all 0.3s;
		outline: none;
		box-shadow: none;
		text-shadow: none;
		cursor: pointer;
	}


}

@media (max-width: 992px) {
	.navbar .navbar-brand {
		position: relative;
		left: 30px;
		top: -20px;
		bottom:50px;
		padding-top:40px
}
	.navbar .navbar-brand {
		width: auto;
	}
	.navbar:after {
		display: none;
	}
	#navbarResponsive {
	    z-index: 99999;
	    position: absolute;
	    top: 80px;
	    left: 0;
	    width: 100%;
	    text-align: center;
	    background-color: #fff;
	    box-shadow: 0px 10px 10px rgba(0,0,0,0.1);
	}
	.navbar .navbar-nav .nav-item {
		border-bottom: 1px solid #eee;
	}
	.navbar .navbar-nav .nav-item:last-child {
		border-bottom: none;
	}
	.navbar .navbar-nav a.nav-link {
		padding: 15px 0px;
		color: #1e1e1e!important;
	}
	.navbar .navbar-nav .nav-link:hover,
	.navbar .navbar-nav .active>.nav-link,
	.navbar .navbar-nav .nav-link.active,
	.navbar .navbar-nav .nav-link.show,
	.navbar .navbar-nav .show>.nav-link {
		color: #03AC13!important;
		border-bottom: none!important;
	}
	.filled-button2 {
		background-color: #00933F;
		color: #fff;
		border: none;
		font-size: 8px;
		text-transform: uppercase;
		font-weight: 700;
		border-radius: 30px;
		display: inline-block;
		transition: all 0.3s;
		outline: none;
		box-shadow: none;
		text-shadow: none;
		cursor: pointer;
	}
}

h5 a { color: #03AC13; } 
h5 a:hover { color: inherit; } 


.product-rating {
    line-height: 22px;
}
.product-rating i {
    color: #fc0;
    display: inline-block;
    margin-right: 2px;
    font-size: 14px;
}
@media screen and (max-width: 1199px) {
    .product-rating {
        margin-bottom: 5px;
        font-size: 15px;
    }
}
@media screen and (max-width: 767px) {
    .product-rating i {
        font-size: 13px;
    }
}
.text-secondary {
    color: #004975 !important;
}
.card-wrapper {
    position: relative;
    overflow: hidden;
}
.card-wrapper .card-img {
    text-align: center;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease-out;
}
.card-wrapper .card-img img {
    transition: all 0.3s ease-in-out;
    border-radius: 0.25rem;
    border-radius: 0.25rem;
}
.card-wrapper .card-body {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    visibility: hidden;
    padding: 30px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    transform: translateX(-100%);
    transition: 0.8s;
    z-index: 11;
}
.card-wrapper:before {
    content: "";
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0;
    right: 100%;
    z-index: 9;
    transition: 0.8s;
    background: #4dce62;
    border-radius: 0.25rem;
}
.card-wrapper:hover:before {
    right: 0;
}
.card-wrapper h3,
.card-wrapper p {
    color: #fff;
}
.card-wrapper .read-more {
    color: #fff;
}
.card-wrapper .read-more:after {
    color: #fff;
}
.card-wrapper:hover .card-body {
    visibility: visible;
    transform: translateX(0px);
}
.card-wrapper:hover .backgound-color {
    right: 0;
}
.ti-shopping-cart:before {
    content: "\\e60d";
}
.mb-2-6, .my-2-6 {
    margin-bottom: 2.6rem;
}
.text-primary {
    color: #00baee !important;
}


.hoverCollapse {
	border-radius: 5px;
	color: #000;
	
}

.hoverCollapse:hover{
	color:#2f975c;
	transition: 1s;
}

.tagCollapse {
	color :"#03AC13"
}
.tagCollapse:hover {
	color :"#F8F9FA"
}


@media screen and (max-width: 1199px) {
    .text-mobile-center {
        text-align: center;
    }

	.reserver-mobile-center {
        display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;

    }
}
@media screen and (max-width: 767px) {
	.text-mobile-center {
        text-align: center;
    }

	.reserver-mobile-center {
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;

    }

	.show-text{
		display: none;
	}

	
	.mobile-height{
		height:500px;
	}

	.text-banner-btn-size {
		font-size: 10px;
	}

	.title-banner-size-mobile {
		font-size: 18px;
		color:#fff;
		text-align: justify;

	}



	.btn-space {
		margin-top: 8px;
		display: inline-flex;
	}

}

.btn-space{
}
.text-banner-btn-size {
	font-size: 17px;
}


.title-banner-size {
	font-size: 40px;
	color:#fff;
}



.reserver-web-center {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

}

.size-title-banner {
	font-size: 40px;
	color:#fff;
}


.img-banner {
	filter: grayscale(20%);
	opacity: 0.5;
	background-size: contain;
	min-width: 100%;
	min-height: 'auto';
}


/* Style de base pour le carousel */
.carousel-container {
	position: relative;
	margin: auto;
	overflow: hidden;
	height: 100vh;
	min-width: 100%;
  }
  
  .carousel {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
  }
  
  .carousel-items {
	display: flex;
	transition: transform 0.5s ease;
	width: 100%;
  }
  
  .carousel-item {
	flex-shrink: 0;
	width: 100%;
	position: relative;
	text-align: center;
	opacity: 0; /* Masquer par défaut */
	transition: opacity 1s ease-in-out;
  }
  
  .carousel-item.active {
	opacity: 1; /* Afficher l'élément actif */
  }
  
  .carousel-item img {
	width: 100%;
	height: 100vh; /* Ajustez la hauteur du carousel */
	object-fit: cover;
  }
  
  /* Texte sur l'image */

  

  
  .button-group {
	margin-top: 20px;
  }
  
  .button-group .btn {
	background-color: #03AC13;
	color: white;
	padding: 10px 20px;
	margin: 5px;
	text-decoration: none;
	border-radius: 5px;
  }
  
  .button-group .btn:hover {
	background-color: #02a611;
  }
  
  /* Navigation des boutons */
  .carousel-button {
	position: absolute;
	top: 50%;
	background-color: rgba(0, 0, 0, 0.5);
	color: white;
	border: none;
	font-size: 2rem;
	padding: 10px;
	cursor: pointer;
	z-index: 10;
  }
  
  .carousel-button:hover {
	background-color: rgba(0, 0, 0, 0.8);
  }
  
  .prev {
	left: 10px;
  }
  
  .next {
	right: 10px;
  }
  
  /* Animation de transition pour les éléments actifs */
  .carousel-item.active {
	opacity: 1;
	transition: opacity 1s ease;
  }
  
  /* Masquer les éléments non actifs */
  .carousel-item:not(.active) {
	opacity: 0;
  }
  `, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAIA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;CACnC,UAAU;CACV,iBAAiB;;AAElB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,oBAAoB;CACpB,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA,kBAAkB;;AAElB;CACC,yBAAyB;CACzB,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,UAAU;AACX;AACA,gBAAgB;AAChB;CACC,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,yBAAyB;AAC1B;;;;AAIA;CACC,6BAA6B;CAC7B,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,oBAAoB;CACpB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;AACZ;;;AAGA;CACC,sBAAsB;CACtB,cAAc;CACd,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;CACzB,UAAU;AACX;;AAEA,iBAAiB;;AAEjB;CACC,sBAAsB;CACtB,WAAW;CACX,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;;AAE1B;;;AAGA;CACC,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA,cAAc;;;AAGd;CACC,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,sBAAsB;AACvB;;;AAGA;CACC,yBAAyB;;CAEzB,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;AACrB;;;;AAIA,QAAQ;AACR;CACC,kBAAkB;CAClB,MAAM;CACN,YAAY;CACZ,QAAQ;CACR,WAAW;CACX,cAAc;CACd,eAAe;CACf,UAAU;CACV,gBAAgB;CAChB,aAAa;EACZ;;EAEA;CACD,YAAY;CAEV,wBAAwB;CAC1B,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,SAAS;CACT,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,mBAAmB;EAClB;;AAEF;CACC,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,yBAAyB;CACzB,eAAe;CACf,WAAW;CACX,mBAAmB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EAEnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EAEZ,uCAAuC;AACzC;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;AAC3B;;AAkBA;EACE;IACE,UAAU;IAEV,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB;;AAErB;CACC,yBAAyB;CACzB,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,4CAA4C;CAC5C,iBAAiB;AAClB;;AAEA;CACC,6CAA6C;CAC7C,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,6CAA6C;AAC9C;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,aAAa;AACd;;;;AAIA,iBAAiB;AACjB;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,uCAAuC;CACvC,YAAY;CAIT,mCAAmC;AACvC;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,MAAM;CACN,eAAe;CACf,YAAY;CACZ,gCAAgC;CAChC,wCAAwC;AACzC;AACA;CACC,wBAAwB;AACzB;AACA;CACC,wBAAwB;AACzB;AACA;;;;;CAKC,wBAAwB;AACzB;AACA;CACC,YAAY;CACZ,aAAa;CACb,iBAAiB;;AAElB;AACA;CACC,WAAW;CACX,yBAAyB;CAItB,2BAA2B;AAC/B;AACA;CACC,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,WAAW;CACX,oBAAoB;CACpB,eAAe;AAChB;AACA;;;;;CAKC,cAAc;CACd,gCAAgC;AACjC;AACA;CACC,sBAAsB;AACvB;AACA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,0BAA0B;AAC3B;;;AAGA,iBAAiB;;AAEjB;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB;AACF;AACA;CACC,WAAW;CACX,UAAU;CACV,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,QAAQ;CACR;AACD;AACA;CACC,UAAU;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;EAIE,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;CACC,sBAAsB;CACtB,kCAAkC;CAClC,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;CACC,yDAA4C;AAC7C;;AAEA;CACC,yDAA4C;AAC7C;;AAEA;CACC,yDAA2C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,eAAe;EACf,6BAA6B;AAC/B;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gBAAgB,eAAe,CAAC;;;AAGhC,mCAAmC;AACnC,cAAc,iBAAiB,CAAC,aAAa,CAAC,wBAAwB,CAA4C,gBAAgB,CAAC,0BAA0B,CAAC,uBAAuB,CAAwB,kBAAkB,CAAC,uCAAuC;AACvQ,YAAY,iBAAiB,CAAC,aAAa,CAAC,eAAe,CAAC,QAAQ,CAAC,SAAS;AAC9E,kBAAkB,YAAY,CAAC,qBAAqB,WAAW;AAC/D,qDAA2H,4BAA4B;AACvJ,aAAa,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,aAAa;AACzD,uCAAuC,aAAa,CAAC,UAAU,CAAC,mBAAmB,UAAU;AAC7F,4BAA4B,iBAAiB;AAC7C,aAAa,YAAY,CAAC,wCAAwC,CAAC,WAAW,CAAC,cAAc;AAC7F,0BAA0B,mBAAmB;AAC7C,gCAAgC,aAAa;AAC7C,4BAA4B,iBAAiB;AAC7C,6BAA6B,aAAa,CAAC,WAAW,CAAC,4BAA4B;;;;;AAKnF,iBAAiB;;AAEjB;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;;;;AAKA,aAAa;;AAEb;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;;;;CAIC,YAAY;CACZ,qBAAqB;CACrB,yBAAyB;AAC1B;;;AAGA,cAAc;;AAEd;CACC,iBAAiB;CACjB,yDAA+C;CAC/C,kCAAkC;CAClC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iCAAiC;CACjC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,uCAAuC;CACvC,4BAA4B;CAC5B,gBAAgB;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;;;AAIA,cAAc;;AAEd;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;;AAGA,uBAAuB;;;AAGvB;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA,oBAAoB;;AAEpB;CACC,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;CACvC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,iBAAiB;CACjB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,iBAAiB;CACjB,iBAAiB;CACjB,qBAAqB;CACrB,aAAa;CACb,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,YAAY;AACb;AAQA;EACE,WAAW;AACb;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX,sBAAsB;CACtB,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,cAAc;AACf;;;;AAIA,mBAAmB;;AAEnB;CACC,0BAA0B;AAC3B;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;;;AAIA,iBAAiB;;AAEjB;CACC,yBAAyB;CACzB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;AACA,gBAAgB;;AAEhB;CACC,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;CAClB,sBAAsB;CACtB,cAAc;CACd,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;CAClB,sBAAsB;CACtB,cAAc;CACd,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,iBAAiB;CACjB,qBAAqB;CACrB,iBAAiB;CACjB,qBAAqB;CACrB,yBAAyB;CACzB,eAAe;CACf,oBAAoB;CACpB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,iBAAiB;CACjB,iBAAiB;CACjB,qBAAqB;CACrB,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,eAAe;CACf,oBAAoB;CACpB,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;AAC1B;AAQA;EACE,WAAW;AACb;;AAEA;CACC,6BAA6B;CAC7B,WAAW;CACX,yBAAyB;CACzB,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,oBAAoB;CACpB,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,cAAc;AACf;;;;AAIA,qBAAqB;;AAErB;CACC,yBAAyB;CACzB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;;AAGA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,mDAAmD;CACnD,kCAAkC;CAClC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;EACjB,YAAY;;AAEd;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iCAAiC;CACjC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;AACA,cAAc;AACd;CACC,kBAAkB;CAClB,yDAAyC;CACzC,kCAAkC;CAClC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iCAAiC;CACjC,UAAU;;AAEX;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;AACA,qBAAqB;AACrB;CACC,kBAAkB;CAClB,mDAAmD;CACnD,kCAAkC;CAClC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iCAAiC;CACjC,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;;AAEA,gBAAgB;;AAEhB;CACC,kBAAkB;CAClB,yDAAsD;CACtD,kCAAkC;CAClC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iCAAiC;CACjC,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;;;AAGA,qBAAqB;;AAErB;CACC,kBAAkB;CAClB,yDAA0C;CAC1C,kCAAkC;CAClC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iCAAiC;CACjC,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;;AAEA,mBAAmB;AACnB;CACC,kBAAkB;CAClB,yDAA0D;CAC1D,kCAAkC;CAClC,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iCAAiC;CACjC,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,cAAc;AACf;;AAEA,qBAAqB;AACrB;CACC,YAAY;CAEZ,2BAA2B;AAC5B;AACA;CACC,YAAY;CACZ,+BAA+B;CAC/B,6BAA6B;;AAE9B;;AAEA,aAAa;;AAEb;CACC,cAAc;CACd,WAAW;CACX,uBAAuB;AACxB;;AAEA,SAAS;;AAET;CACC,yBAAyB;CACzB,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;;AAGA,mBAAmB;;AAEnB;CACC,iBAAiB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;CACC,0BAA0B;CAC1B,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,mBAAmB;GACjB,eAAe;GACf,cAAc;GACd,qBAAqB;GACrB,gBAAgB;GAChB,oBAAoB;AACvB;AACA;CACC,YAAY;CACZ,eAAe;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;CACC,iBAAiB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA,wBAAwB;;AAExB;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;AAChB;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;;;;;AAMA,qBAAqB;AACrB;CACC;EACC,aAAa;CACd;CACA;GACE,mBAAmB;GACnB,eAAe;CACjB;CACA;GACE,mBAAmB;GACnB,eAAe;GACf,iBAAiB;GACjB,mBAAmB;CACrB;CACA;EACC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;CACpB;CACA;GACE,SAAS;CACX;CACA;GACE,QAAQ;CACV;CACA;EACC,kBAAkB;CACnB;CACA;EACC,WAAW;EACX,gBAAgB;CACjB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,iBAAiB;EACjB,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,0BAA0B;;CAE3B;CACA;EACC,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;CACrB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,iBAAiB;EACjB,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,mBAAmB;CACpB;;CAEA;EACC,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;;;AAGD;;AAEA;CACC;EACC,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX;AACF;CACC;EACC,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;KACI,cAAc;KACd,kBAAkB;KAClB,SAAS;KACT,OAAO;KACP,WAAW;KACX,kBAAkB;KAClB,sBAAsB;KACtB,yCAAyC;CAC7C;CACA;EACC,6BAA6B;CAC9B;CACA;EACC,mBAAmB;CACpB;CACA;EACC,iBAAiB;EACjB,wBAAwB;CACzB;CACA;;;;;EAKC,wBAAwB;EACxB,6BAA6B;CAC9B;CACA;EACC,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;AACD;;AAEA,OAAO,cAAc,EAAE;AACvB,aAAa,cAAc,EAAE;;;AAG7B;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,QAAQ;AACZ;AACA;;IAEI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,QAAQ;AACZ;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;;;AAGA;CACC,kBAAkB;CAClB,WAAW;;AAEZ;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC;AACD;AACA;CACC;AACD;;;AAGA;IACI;QACI,kBAAkB;IACtB;;CAEH;QACO,aAAa;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;IAEhB;AACJ;AACA;CACC;QACO,kBAAkB;IACtB;;CAEH;EACC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;IAEhB;;CAEH;EACC,aAAa;CACd;;;CAGA;EACC,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,UAAU;EACV,mBAAmB;;CAEpB;;;;CAIA;EACC,eAAe;EACf,oBAAoB;CACrB;;AAED;;AAEA;AACA;AACA;CACC,eAAe;AAChB;;;AAGA;CACC,eAAe;CACf,UAAU;AACX;;;;AAIA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;;AAEnB;;AAEA;CACC,eAAe;CACf,UAAU;AACX;;;AAGA;CACC,sBAAsB;CACtB,YAAY;CACZ,wBAAwB;CACxB,eAAe;CACf,kBAAkB;AACnB;;;AAGA,mCAAmC;AACnC;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,eAAe;EACd;;EAEA;CACD,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;EACtB;;EAEA;CACD,aAAa;CACb,+BAA+B;CAC/B,WAAW;EACV;;EAEA;CACD,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,UAAU,EAAE,uBAAuB;CACnC,kCAAkC;EACjC;;EAEA;CACD,UAAU,EAAE,6BAA6B;EACxC;;EAEA;CACD,WAAW;CACX,aAAa,EAAE,mCAAmC;CAClD,iBAAiB;EAChB;;EAEA,sBAAsB;;;;;EAKtB;CACD,gBAAgB;EACf;;EAEA;CACD,yBAAyB;CACzB,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,qBAAqB;CACrB,kBAAkB;EACjB;;EAEA;CACD,yBAAyB;EACxB;;EAEA,2BAA2B;EAC3B;CACD,kBAAkB;CAClB,QAAQ;CACR,oCAAoC;CACpC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,aAAa;CACb,eAAe;CACf,WAAW;EACV;;EAEA;CACD,oCAAoC;EACnC;;EAEA;CACD,UAAU;EACT;;EAEA;CACD,WAAW;EACV;;EAEA,qDAAqD;EACrD;CACD,UAAU;CACV,2BAA2B;EAC1B;;EAEA,oCAAoC;EACpC;CACD,UAAU;EACT","sourcesContent":["@import \"~react-image-gallery/styles/css/image-gallery.css\";\n@import '~react-phone-number-input/style.css';\n\n\nbody {\n  font-family: 'Aqua Grotesque', serif;\n  overflow-x: hidden;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\twidth:100%;\n\tposition:absolute;\n\n}\n\ninput {\n\tborder: 1px solid green;\n}\n\n.has-error input[type=\"text\"], .has-error input[type=\"email\"], .has-error input {\n    border: 1px solid #a94442;\n}\n\n::-webkit-scrollbar {\n\twidth: 13px;\n}\n\n::-webkit-scrollbar-track {\n\tbackground: #fff;\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground: #03AC13;\n}\n\nspan{\n\ttext-transform:none;\n}\np {\n\tmargin-bottom: 0px;\n\tfont-size: 14px;\n\tcolor: #666666;\n\tline-height: 30px;\n}\na {\n\ttext-transform : 'lowercase';\n}\nul {\n\tpadding: 0;\n\tmargin: 0;\n\tlist-style: none;\n}\n\nh1,h2,h3,h4,h5,h6 {\n\tmargin: 0px;\n}\n\n.last:last-child{\n\tjustify-content: center;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tjustify-items: center;\n\tjustify-self: center;\n\ttext-align: center;\n\talign-content: center;\n}\n\n/*Link Activities*/\n\n.filled-btn-acti{\n\tborder: 1px solid #03AC13;\n\tcolor: #03AC13;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\tbackground-color: transparent;\n}\n\n.filled-btn-acti:hover {\n\tbackground-color: #03AC13;\n\tborder: 1px solid #03AC13;\n\tcolor:#fff;\n}\n/*Link On Hover*/\n.filled-btn{\n\tborder: 1px solid #03AC13;\n\tcolor: #fff;\n\tfont-size: 13px;\n\ttext-transform: capitalize;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\tbackground-color: #03AC13;\n}\n\n\n\n.filled-btn:hover {\n\tbackground-color: transparent;\n\tborder: 1px solid #03AC13;\n}\n\n.filled-btn-avis{\n\tborder: 1px solid #03AC13;\n\tcolor: #fff;\n\tfont-size: 13px;\n\ttext-transform: none;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\tbackground-color: #03AC13;\n}\n\n.filled-btn-avis:hover {\n\tbackground-color: transparent;\n\tborder: 1px solid #03AC13;\n\tcolor:#03AC13;\n}\n\n.filled-btn-scroll{\n\tborder: 3px solid #fff;\n\tcolor: white;\n\tfont-size: 13px;\n\ttext-transform: capitalize;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\tbackground-color: transparent;\n}\n\n.filled-btn-scroll:hover {\n\tbackground-color: #03AC13;\n\tborder: 1px solid #03AC13;\n\tcolor:white;\n}\n\n\n.filled-btn-visite{\n\tborder: 1px solid #fff;\n\tcolor: #03AC13;\n\tfont-size: 12px;\n\ttext-transform: capitalize;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\tbackground-color: #fff;\n}\n\n.filled-btn-visite:hover {\n\tbackground-color: transparent;\n\tborder: 1px solid #03AC13;\n\tcolor:#fff;\n}\n\n/*Consulter menu*/\n\n.filled-btn-reverse{\n\tborder: 1px solid #fff;\n\tcolor: #fff;\n\tfont-size: 13px;\n\ttext-transform: capitalize;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\tbackground-color: transparent;\n}\n\n.filled-btn-reverse:hover {\n\tbackground-color: transparent;\n\tborder: 1px solid #03AC13;\n\n}\n\n\na.filled-button {\n\tbackground-color: #03AC13;\n\tcolor: #fff;\n\tfont-size: 16px;\n\ttext-transform: capitalize;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 1s;\n}\n\na.filled-button:hover {\n\tbackground-color: transparent;\n\tcolor: #03AC13;\n\tborder: 1px solid #03AC13;\n}\n\na.border-button {\n\tbackground-color: transparent;\n\tcolor: #fff;\n\tborder: 2px solid #fff;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 10px 28px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n}\n\n/*Pack Button*/\n\n\n.filled-btn-pack{\n\tborder: 1px solid #03AC13;\n\tcolor: #fff;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\tbackground-color: #03AC13;\n}\n\n.filled-btn-pack:hover {\n\tbackground-color: transparent;\n\tborder: 1px solid #fff;\n}\n\n\na.filled-btn-pack {\n\tbackground-color: #03AC13;\n\t\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n}\n\na.filled-btn-pack:hover {\n\tborder: 1px solid #03AC13;\n}\n\na.border-btn-pack {\n\tbackground-color: transparent;\n\tcolor: #fff;\n\tborder: 2px solid #fff;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 10px 28px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n}\n\n\n\n/*Badge*/\n.price-badge {\n\tposition: absolute;\n\ttop: 0;\n\tz-index: 999;\n\tright: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 15px;\n\tpadding: 0;\n\toverflow: hidden;\n\theight: 100px;\n  }\n  \n  .price-badge .badge {\n\tfloat: right;\n\t-webkit-transform: rotate(45deg);\n\t\t\ttransform: rotate(45deg);\n\tright: -67px;\n\ttop: 17px;\n\tposition: relative;\n\ttext-align: center;\n\twidth: 200px;\n\tfont-size: 13px;\n\tmargin: 0;\n\tpadding: 7px 10px;\n\tfont-weight: 500;\n\tcolor: #ffffff;\n\tbackground: #03AC13;\n  }\n\na.border-button:hover {\n\tbackground-color: #fff;\n\tcolor: #03AC13;\n}\n\n.section-heading {\n\ttext-align: center;\n\tmargin-bottom: 80px;\n}\n\n.section-heading h2 {\n\tfont-size: 36px;\n\tfont-weight: 600;\n\tcolor: #1e1e1e;\n}\n\n.section-heading em {\n\tfont-style: normal;\n\tcolor: #03AC13;\n}\n\n.section-heading span {\n\tdisplay: block;\n\tmargin-top: 15px;\n\ttext-transform: uppercase;\n\tfont-size: 15px;\n\tcolor: #666;\n\tletter-spacing: 1px;\n}\n\n#preloader {\n  overflow: hidden;\n  background: #ffffff;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: fixed;\n  z-index: 9999999;\n  color: #fff;\n}\n\n#preloader .jumper {\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: block;\n  position: absolute;\n  margin: auto;\n  width: 50px;\n  height: 50px;\n}\n\n#preloader .jumper > div {\n  background-color: #fff;\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  position: absolute;\n  opacity: 0;\n  width: 50px;\n  height: 50px;\n  -webkit-animation: jumper 1s 0s linear infinite;\n  animation: jumper 1s 0s linear infinite;\n}\n\n#preloader .jumper > div:nth-child(2) {\n  -webkit-animation-delay: 0.33333s;\n  animation-delay: 0.33333s;\n}\n\n#preloader .jumper > div:nth-child(3) {\n  -webkit-animation-delay: 0.66666s;\n  animation-delay: 0.66666s;\n}\n\n@-webkit-keyframes jumper {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n@keyframes jumper {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/* Sub Header Style */\n\n.sub-header {\n\tbackground-color: #03AC13;\n\theight: 46px;\n\tposition:relative;\n\tline-height: 46px;\n}\n\n.sub-header ul li {\n\tdisplay: inline-block;\n}\n\n.sub-header ul.left-info li {\n\tborder-left: 1px solid rgba(250,250,250,0.3);\n\tpadding: 0px 20px;\n}\n\n.sub-header ul.left-info  {\n\tborder-right: 1px solid rgba(250,250,250,0.3);\n\twidth: max-content;\n}\n\n.sub-header ul.left-info li i {\n\tmargin-right: 10px;\n\tfont-size: 18px;\n}\n\n.sub-header ul.left-info li a {\n\tcolor: #fff;\n\tfont-size: 14px;\n\tfont-weight: 600;\n}\n\n.sub-header ul.right-icons {\n\tfloat: right;\n}\n\n.sub-header ul.right-icons li {\n\tmargin-right: -4px;\n\twidth: 46px;\n\tdisplay: inline-block;\n\ttext-align: center;\n\tborder-right: 1px solid rgba(250,250,250,0.3);\n}\n\n.sub-header ul.right-icons li:first-child {\n\tborder-left: 1px solid rgba(250,250,250,0.3);\n}\n\n.sub-header ul.right-icons li a {\n\tcolor: #fff;\n\ttransition: all 0.3s;\n}\n\n.sub-header ul.right-icons li a:hover {\n\topacity: 0.75;\n}\n\n\n\n/* Header Style */\nheader {\n\tposition: absolute;\n\tz-index: 99999;\n\twidth: 100%;\n\tbackground-color: transparent!important;\n\theight: 80px;\n\t-webkit-transition: all 0.3s ease-in-out 0s;\n    -moz-transition: all 0.3s ease-in-out 0s;\n    -o-transition: all 0.3s ease-in-out 0s;\n    transition: all 0.3s ease-in-out 0s;\n}\nheader .navbar {\n\tpadding: 20px 0px;\n}\n.background-header .navbar {\n\tpadding: 10px 0px;\n}\n.background-header {\n\ttop: 0;\n\tposition: fixed;\n\theight:100px;\n\tbackground-color: #fff!important;\n\tbox-shadow: 0px 1px 10px rgba(0,0,0,0.1);\n}\n.background-header .navbar-brand {\n\tcolor: #028A0F!important;\n}\n.background-header .navbar-nav a.nav-link {\n\tcolor: #1e1e1e!important;\n}\n.background-header .navbar-nav .nav-link:hover,\n.background-header .navbar-nav .active>.nav-link,\n.background-header .navbar-nav .nav-link.active,\n.background-header .navbar-nav .nav-link.show,\n.background-header .navbar-nav .show>.nav-link {\n\tcolor: #03AC13!important;\n}\n.navbar .navbar-brand {\n\tfloat: \tleft;\n\toutline: none;\n\tposition:relative;\n\n}\n.navbar .navbar-brand h2 {\n\tcolor: #fff;\n\ttext-transform: uppercase;\n\t-webkit-transition: all .3s ease 0s;\n    -moz-transition: all .3s ease 0s;\n    -o-transition: all .3s ease 0s;\n    transition: all .3s ease 0s;\n}\n.navbar .navbar-brand h2 em {\n\tfont-style: normal;\n\tfont-size: 16px;\n}\n#navbarResponsive {\n\tz-index: 999;\n}\n.navbar-collapse {\n\ttext-align: center;\n}\n.navbar .navbar-nav .nav-item {\n\tmargin: 0px 8px;\n}\n.navbar .navbar-nav a.nav-link {\n\ttext-transform: capitalize;\n\tfont-size: 15px;\n\tfont-weight: 300;\n\tletter-spacing: 0.5px;\n\tcolor: #fff;\n\ttransition: all 0.5s;\n\tmargin-top: 5px;\n}\n.navbar .navbar-nav .nav-link:hover,\n.navbar .navbar-nav .active>.nav-link,\n.navbar .navbar-nav .nav-link.active,\n.navbar .navbar-nav .nav-link.show,\n.navbar .navbar-nav .show>.nav-link {\n\tcolor: #03AC13;\n\tborder-bottom: 3px solid #a4c639;\n}\n.navbar .navbar-toggler-icon {\n\tbackground-image: none;\n}\n.navbar .navbar-toggler {\n\topacity: 0.5;\n\toutline: none;\n\tposition: absolute;\n\tright: 30px;\n\ttop: 30px;\n}\n.navbar .navbar-toggler-icon:after {\n\tcontent: '\\f0c9';\n\tcolor: #03AC13;\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-family: 'FontAwesome';\n}\n\n\n/* Banner Style */\n\n.img-fill{\n  width: 100%;\n  display: block;\n  overflow: hidden;\n  position: relative;\n  text-align: center\n}\n.img-fill:before {\n\tcontent: '';\n\tz-index: 1;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom:0;\n\tright: 0;\n\tbackground-color: rgba(0,0,0,.6)\n}\n.Modern-Slider .text-content{\n\tz-index: 2;\n}\n\n.img-fill img {\n  min-height: 100%;\n  min-width: 100%;\n  position: relative;\n  display: inline-block;\n  max-width: none;\n}\n\n*,\n*:before,\n*:after {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.Grid1k {\n  padding: 0 15px;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.blocks-box,\n.slick-slider {\n  margin: 0;\n  padding: 0!important;\n}\n\n.slick-slide {\n  float: left;\n  padding: 0;\n}\n\n.Modern-Slider .item .img-fill {\n\tbackground-size: cover;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\theight:95vh;\n}\n\n.Modern-Slider .item-1 .img-fill {\n\tbackground-image: url(../images/Photo1.jpeg);\n}\n\n.Modern-Slider .item-2 .img-fill {\n\tbackground-image: url(../images/Photo2.jpeg);\n}\n\n.Modern-Slider .item-3 .img-fill {\n\tbackground-image: url(../images/photo3.jpg);\n}\n\n.Modern-Slider .NextArrow{\n  position:absolute;\n  top:50%;\n  right:30px;\n  border:0 none;\n  background-color: transparent;\n  text-align:center;\n  font-size: 36px;\n  font-family: 'FontAwesome';\n  color:#FFF;\n  z-index:5;\n  outline: none;\n  cursor: pointer;\n}\n\n.Modern-Slider .NextArrow:before{\n  content:'\\f105';\n}\n\n.Modern-Slider .PrevArrow {\n  position:absolute;\n  top:50%;\n  left:30px;\n  border:0 none;\n  background-color: transparent;\n  text-align:center;\n  font-size: 36px;\n  font-family: 'FontAwesome';\n  color:#FFF;\n  z-index:5;\n  outline: none;\n  cursor: pointer;\n}\n\n.Modern-Slider .PrevArrow:before{\n  content:'\\f104';\n}\n\nul.slick-dots {\n  display: none!important;\n}\n\n\n.Modern-Slider .item h6 {\n  margin-bottom: 15px;\n  font-size: 22px;\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color:#03AC13;\n  animation:fadeOutRight 1s both;\n}\n\n.Modern-Slider .item h4 {\n  margin-bottom: 30px;\n  text-transform: uppercase;\n  font-size: 44px;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n  color:#FFF;\n  overflow:hidden;\n  animation:fadeOutLeft 1s both;\n}\n\n.Modern-Slider .item p {\n\tmax-width: 570px;\n\tcolor: #fff;\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tline-height: 30px;\n\tmargin-bottom: 40px;\n}\n\n.Modern-Slider .item a {\n  margin: 0 5px;\n}\n\n.Modern-Slider .item.slick-active h6{\n  animation:fadeInDown 1s both 1s;\n}\n\n.Modern-Slider .item.slick-active h4{\n  animation:fadeInLeft 1s both 1.5s;\n}\n\n.Modern-Slider .item.slick-active{\n  animation:Slick-FastSwipeIn 1s both;\n}\n\n.Modern-Slider .buttons {\n  position: relative;\n}\n\n.Modern-Slider {background:#000;}\n\n\n/* ==== Slick Slider Css Ruls === */\n.slick-slider{position:relative;display:block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}\n.slick-list{position:relative;display:block;overflow:hidden;margin:0;padding:0}\n.slick-list:focus{outline:none}.slick-list.dragging{cursor:hand}\n.slick-slider .slick-track,.slick-slider .slick-list{-webkit-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}\n.slick-track{position:relative;top:0;left:0;display:block}\n.slick-track:before,.slick-track:after{display:table;content:''}.slick-track:after{clear:both}\n.slick-loading .slick-track{visibility:hidden}\n.slick-slide{display:none;float:left /* If RTL Make This Right */ ;height:100%;min-height:1px}\n.slick-slide.dragging img{pointer-events:none}\n.slick-initialized .slick-slide{display:block}\n.slick-loading .slick-slide{visibility:hidden}\n.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}\n\n\n\n\n/* Request Form */\n\n.request-form {\n\tbackground-color: #03AC13;\n\tcolor: #fff;\n}\n\n.request-form h4 {\n\tfont-size: 22px;\n\tfont-weight: 600;\n}\n\n.request-form span {\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tdisplay: inline-block;\n\tmargin-top: 10px;\n}\n\n.request-form a.border-button {\n\tmargin-top: 12px;\n\tfloat: right;\n}\n\n\n\n\n/* Services */\n\n.services {\n\tmargin-top: 140px;\n}\n\n.service-item img {\n\twidth: 100%;\n\toverflow: hidden;\n}\n\n.service-item .down-content {\n\tbackground-color: #f7f7f7;\n\tpadding: 30px;\n}\n\n.service-item .down-content h4 {\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tletter-spacing: 0.25px;\n\tmargin-bottom: 15px;\n}\n\n.service-item .down-content p {\n\tmargin-bottom: 20px;\n}\n\n.page-link:hover,\n.page-link {\n\tcolor: #03AC13;\n}\n\n.btn-primary {\n\tborder-color: #03AC13;\n\tbackground-color: #03AC13;\n}\n\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary:active:focus{\n\topacity: 0.6;\n\tborder-color: #a4c639;\n\tbackground-color: #a4c639;\n}\n\n\n/* Fun Facts */\n\n.fun-facts {\n\tmargin-top: 140px;\n\tbackground-image: url(../images/background.jpg);\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-attachment: fixed;\n\tcolor: #fff;\n\tposition: relative;\n}\n\n.fun-facts .container {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fun-facts:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0,0.5);\n\tz-index: 1;\n}\n\n.fun-facts span {\n\ttext-transform: uppercase;\n\tfont-size: 15px;\n\tcolor: #fff;\n\tletter-spacing: 1px;\n\tmargin-bottom: 10px;\n\tdisplay: block;\n}\n\n.fun-facts h2 {\n\tfont-size: 36px;\n\tfont-weight: 600;\n\tmargin-bottom: 35px;\n}\n\n.fun-facts em {\n\tfont-style: normal;\n\tcolor: #a4c639;\n}\n\n.fun-facts p {\n\tcolor: #fff;\n\tmargin-bottom: 40px;\n}\n\n.fun-facts .left-content {\n\tmargin-right: 45px;\n}\n\n.count-area-content {\n\ttext-align: center;\n\tbackground-color: rgba(250,250,250,0.1);\n\tpadding: 25px 30px 35px 30px;\n\tmargin: 15px 0px;\n}\n\n.count-digit {\n    margin: 5px 0px;\n    color: #a4c639;\n    font-weight: 700;\n    font-size: 36px;\n}\n.count-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #fff;\n    letter-spacing: 0.5px;\n}\n\n\n\n/* More Info */\n\n.more-info {\n\tmargin-top: 140px;\n}\n\n.more-info .left-image img {\n\twidth: 100%;\n\toverflow: hidden;\n}\n\n.more-info .more-info-content {\n\tbackground-color: #f7f7f7;\n}\n\n.about-info .more-info-content {\n\tbackground-color: transparent;\n}\n\n.about-info .right-content {\n\tpadding: 0px!important;\n\tmargin-right: 30px;\n}\n\n.more-info .right-content {\n\tpadding: 45px 45px 45px 30px;\n}\n\n.more-info .right-content span {\n\ttext-transform: uppercase;\n\tfont-size: 15px;\n\tcolor: #666;\n\tletter-spacing: 1px;\n\tmargin-bottom: 10px;\n\tdisplay: block;\n}\n\n.more-info .right-content h2 {\n\tfont-size: 36px;\n\tfont-weight: 600;\n\tmargin-bottom: 35px;\n}\n\n.more-info .right-content em {\n\tfont-style: normal;\n\tcolor: #03AC13;\n}\n\n.more-info .right-content p {\n\tmargin-bottom: 30px;\n}\n\n\n/* Testimonials Style */\n\n\n.about-testimonials {\n\tmargin-top: 0px!important;\n}\n\n.testimonials {\n\tmargin-top: 50px;\n\tbackground-color: #ffffff;\n\tpadding: 140px 0px;\n}\n.testimonial-item .inner-content {\n\ttext-align: center;\n\tbackground-color: #fff;\t\n\tpadding: 30px;\n\tborder-radius: 5px;\n}\n.testimonial-item p {\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n.testimonial-item h4 {\n\tfont-size: 19px;\n\tfont-weight: 700;\n\tcolor: #1e1e1e;\n\tletter-spacing: 0.5px;\n\tmargin-bottom: 0px;\n}\n.testimonial-item span {\n\tdisplay: inline-block;\n\tmargin-top: 8px;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tcolor: #03AC13;\n}\n.testimonial-item img {\n\tmax-width: 60px;\n\tborder-radius: 50%;\n\tmargin: 25px auto 0px auto;\n}\n\n/* Call Back Style */\n\n.callback-services {\n\tborder-top: 1px solid #eee;\n\tpadding-top: 140px;\n}\n\n.contact-us {\n\tbackground-color: #f7f7f7;\n\tpadding: 140px 0px;\n}\n\n.contact-us .contact-form {\n\tbackground-color: transparent!important;\n\tpadding: 0!important;\n}\n\n.callback-form {\n\tmargin-top: -50px;\n}\n\n.callback-form .contact-form {\n\tbackground-color: #00933F;\n\tpadding: 60px;\n\tborder-radius: 15px;\n\ttext-align: center;\n}\n\n.callback-form .contact-form input {\n\tborder-radius: 20px;\n\theight: 40px;\n\tline-height: 40px;\n\tdisplay: inline-block;\n\tpadding: 0px 15px;\n\tcolor: #6a6a6a;\n\tfont-size: 13px;\n\ttext-transform: none;\n\tbox-shadow: none;\n\tborder: none;\n\tmargin-bottom: 35px;\n}\n\n.callback-form .contact-form input:focus {\n\toutline: none;\n\tbox-shadow: none;\n\tborder: none;\n}\n\n.callback-form .contact-form textarea {\n\tborder-radius: 20px;\n\theight: 120px;\n\tmax-height: 200px;\n\tmin-height: 120px;\n\tdisplay: inline-block;\n\tpadding: 15px;\n\tcolor: #6a6a6a;\n\tfont-size: 13px;\n\ttext-transform: none;\n\tbox-shadow: none;\n\tborder: none;\n\tmargin-bottom: 35px;\n}\n\n.callback-form .contact-form textarea:focus {\n\toutline: none;\n\tbox-shadow: none;\n\tborder: none;\n}\n\n.callback-form .contact-form ::-webkit-input-placeholder { /* Edge */\n  color: #aaa;\n}\n.callback-form .contact-form :-ms-input-placeholder { /* Internet Explorer 10-11 */\n  color: #aaa;\n}\n.callback-form .contact-form ::placeholder {\n  color: #aaa;\n}\n\n.callback-form .contact-form button.border-button {\n\tbackground-color: transparent;\n\tcolor: #fff;\n\tborder: 2px solid #fff;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 10px 28px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\toutline: none;\n\tbox-shadow: none;\n\ttext-shadow: none;\n\tcursor: pointer;\n}\n\n.callback-form .contact-form button.border-button:hover {\n\tbackground-color: #fff;\n\tcolor: #00933F;\n}\n\n.contact-us .contact-form button.filled-button {\n\tbackground-color: #00933F;\n\tcolor: #fff;\n\tborder: none;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\toutline: none;\n\tbox-shadow: none;\n\ttext-shadow: none;\n\tcursor: pointer;\n}\n\n.contact-us .contact-form button.filled-button:hover {\n\tbackground-color: #fff;\n\tcolor: #00933F;\n}\n\n.filled-button {\n\tbackground-color: #00933F;\n\tcolor: #fff;\n\tborder: none;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\toutline: none;\n\tbox-shadow: none;\n\ttext-shadow: none;\n\tcursor: pointer;\n}\n\n.filled-button:hover {\n\tbackground-color: #fff;\n\tcolor: #00933F;\n}\n\n\n\n/* Partners Style */\n\n.contact-partners {\n\tmargin-top: -8px!important;\n}\n\n.partners {\n\tmargin-top: 140px;\n\tbackground-color: #f7f7f7;\n\tpadding: 60px 0px;\n}\n\n.partners .owl-item {\n\ttext-align: center;\n\tcursor: pointer;\n}\n\n.partners .partner-item img {\n\tmax-width: 156px;\n\tmargin: auto;\n}\n\n\n\n/* Footer Style */\n\nfooter {\n\tbackground-color: #232323;\n\tpadding: 80px 0px;\n\tcolor: #fff;\n}\n\nfooter h4 {\n\tcolor: #fff;\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tletter-spacing: 0.25px;\n\tmargin-bottom: 35px;\n}\nfooter p {\n\tcolor: #fff;\n}\n\nfooter ul.social-icons {\n\tmargin-top: 25px;\n}\n\nfooter ul.social-icons li {\n\tdisplay: inline-block;\n\tmargin-right: 5px;\n}\n\nfooter ul.social-icons li:last-child {\n\tmargin-right: 0px;\n}\n/*Contact icons*/\n\nfooter .contact-icons {\n\twidth: 34px;\n\theight: 34px;\n\tdisplay: inline-block;\n\tline-height: 34px;\n\ttext-align: center;\n\tbackground-color: #fff;\n\tcolor: #232323;\n\tborder-radius: 50%;\n\ttransition: all 0.3s;\n}\n\nfooter .contact-icons:hover {\n\tbackground-color: #03AC13;\n\tcolor: white;\n}\n\nfooter ul.social-icons li a {\n\twidth: 34px;\n\theight: 34px;\n\tdisplay: inline-block;\n\tline-height: 34px;\n\ttext-align: center;\n\tbackground-color: #fff;\n\tcolor: #232323;\n\tborder-radius: 50%;\n\ttransition: all 0.3s;\n}\n\nfooter ul.social-icons li a:hover {\n\tbackground-color: #03AC13;\n\tcolor: white;\n}\n\nfooter ul.menu-list li {\n\tmargin-bottom: 13px;\n}\n\nfooter ul.menu-list li:last-child {\n\tmargin-bottom: 0px;\n}\n\nfooter ul.menu-list li a {\n\tfont-size: 14px;\n\tcolor: #fff;\n\ttransition: all 0.3s;\n}\n\nfooter ul.menu-list li a:hover {\n\tcolor: #03AC13;\n}\n\nfooter .contact-form input {\n\tborder-radius: 20px;\n\theight: 40px;\n\tline-height: 40px;\n\tdisplay: inline-block;\n\tpadding: 0px 15px;\n\tcolor: #aaa!important;\n\tbackground-color: #343434;\n\tfont-size: 13px;\n\ttext-transform: none;\n\tbox-shadow: none;\n\tborder: none;\n\tmargin-bottom: 15px;\n}\n\nfooter .contact-form input:focus {\n\toutline: none;\n\tbox-shadow: none;\n\tborder: none;\n\tbackground-color: #343434;\n}\n\nfooter .contact-form textarea {\n\tborder-radius: 20px;\n\theight: 120px;\n\tmax-height: 200px;\n\tmin-height: 120px;\n\tdisplay: inline-block;\n\tpadding: 15px;\n\tcolor: #aaa!important;\n\tbackground-color: #343434;\n\tfont-size: 13px;\n\ttext-transform: none;\n\tbox-shadow: none;\n\tborder: none;\n\tmargin-bottom: 15px;\n}\n\nfooter .contact-form textarea:focus {\n\toutline: none;\n\tbox-shadow: none;\n\tborder: none;\n\tbackground-color: #343434;\n}\n\nfooter .contact-form ::-webkit-input-placeholder { /* Edge */\n  color: #aaa;\n}\nfooter .contact-form :-ms-input-placeholder { /* Internet Explorer 10-11 */\n  color: #aaa;\n}\nfooter .contact-form ::placeholder {\n  color: #aaa;\n}\n\nfooter .contact-form button.filled-button {\n\tbackground-color: transparent;\n\tcolor: #fff;\n\tbackground-color: #03AC13;\n\tborder: none;\n\tfont-size: 13px;\n\ttext-transform: uppercase;\n\tfont-weight: 700;\n\tpadding: 12px 30px;\n\tborder-radius: 30px;\n\tdisplay: inline-block;\n\ttransition: all 0.3s;\n\toutline: none;\n\tbox-shadow: none;\n\ttext-shadow: none;\n\tcursor: pointer;\n}\n\nfooter .contact-form button.filled-button:hover {\n\tbackground-color: #fff;\n\tcolor: #597D35;\n}\n\n\n\n/* Sub-footer Style */\n\n.sub-footer {\n\tbackground-color: #343434;\n\ttext-align: center;\n\tpadding: 25px 0px;\n}\n\n.sub-footer p {\n\tcolor: #fff;\n\tfont-weight: 300;\n\tletter-spacing: 0.5px;\n}\n\n.sub-footer a {\n\tcolor: #fff;\n}\n\n\n.page-heading {\n\ttext-align: center;\n\tmin-height: 100vh;\n\t/*background-image: url(../images/background.jpg);*/\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 230px 0px 150px 0px;\n\tcolor: #fff;\n\tposition: relative;\n\t\theight:680px;\n\n}\n.page-heading .container {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.page-heading:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0,0.5);\n\tz-index: 1;\n\theight:auto;\n}\n\n.page-heading h1 {\n\ttext-transform: capitalize;\n\tfont-size: 36px;\n\tfont-weight: 700;\n\tletter-spacing: 2px;\n\tmargin-bottom: 18px;\n}\n\n.page-heading span {\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tcolor: #fff;\n\tdisplay: block;\n}\n/*Spa Heading*/\n.page-heading-spa {\n\ttext-align: center;\n\tbackground-image: url(../images/spa.jpeg);\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 230px 0px 150px 0px;\n\tcolor: #fff;\n\tposition: relative;\n}\n.page-heading-spa .container {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.page-heading-spa:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0,0.5);\n\tz-index: 1;\n\t\n}\n\n.page-heading-spa h1 {\n\ttext-transform: capitalize;\n\tfont-size: 36px;\n\tfont-weight: 700;\n\tletter-spacing: 2px;\n\tmargin-bottom: 18px;\n}\n\n.page-heading-spa span {\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tcolor: #fff;\n\tdisplay: block;\n}\n/*Activities Heading*/\n.page-heading-activities {\n\ttext-align: center;\n\t/*background-image: url(../images/background.jpg);*/\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 230px 0px 150px 0px;\n\tcolor: #fff;\n\tposition: relative;\n}\n.page-heading-activities .container {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.page-heading-activities:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0,0.5);\n\tz-index: 1;\n}\n\n.page-heading-activities h1 {\n\ttext-transform: capitalize;\n\tfont-size: 36px;\n\tfont-weight: 700;\n\tletter-spacing: 2px;\n\tmargin-bottom: 18px;\n}\n\n.page-heading-activities span {\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tcolor: #fff;\n\tdisplay: block;\n}\n\n/*Rooms Heading*/\n\n.page-heading-rooms {\n\ttext-align: center;\n\tbackground-image: url(../images/balcon-mandarine.jpeg);\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 230px 0px 150px 0px;\n\tcolor: #fff;\n\tposition: relative;\n}\n.page-heading-rooms .container {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.page-heading-rooms:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0,0.5);\n\tz-index: 1;\n}\n\n.page-heading-rooms h1 {\n\ttext-transform: capitalize;\n\tfont-size: 36px;\n\tfont-weight: 700;\n\tletter-spacing: 2px;\n\tmargin-bottom: 18px;\n}\n\n.page-heading-rooms span {\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tcolor: #fff;\n\tdisplay: block;\n}\n\n\n/*Restaurant Heading*/\n\n.page-heading-rest {\n\ttext-align: center;\n\tbackground-image: url(../images/resto.jpg);\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 230px 0px 150px 0px;\n\tcolor: #fff;\n\tposition: relative;\n}\n.page-heading-rest .container {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.page-heading-rest:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0,0.5);\n\tz-index: 1;\n}\n\n.page-heading-rest h1 {\n\ttext-transform: capitalize;\n\tfont-size: 36px;\n\tfont-weight: 700;\n\tletter-spacing: 2px;\n\tmargin-bottom: 18px;\n}\n\n.page-heading-rest span {\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tcolor: #fff;\n\tdisplay: block;\n}\n\n/*Products Heading*/\n.page-heading-product {\n\ttext-align: center;\n\tbackground-image: url(../images/kaak-warka-patisserie.jpg);\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tpadding: 230px 0px 150px 0px;\n\tcolor: #fff;\n\tposition: relative;\n}\n.page-heading-product .container {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.page-heading-product:before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground-color: rgba(0,0,0,0.5);\n\tz-index: 1;\n}\n\n.page-heading-product h1 {\n\ttext-transform: capitalize;\n\tfont-size: 36px;\n\tfont-weight: 700;\n\tletter-spacing: 2px;\n\tmargin-bottom: 18px;\n}\n\n.page-heading-product span {\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tcolor: #fff;\n\tdisplay: block;\n}\n\n/*Effect Hover Image*/\n.hover03 .figure .img-petit-dej {\n\theight: auto;\n\t-webkit-transition: .3s ease-in-out;\n\ttransition: .3s ease-in-out;\n}\n.hover03 .figure:hover .img-petit-dej {\n\twidth: 530px;\n\tborder-bottom-left-radius: 35px;\n\tborder-top-right-radius: 35px;\n\t\n}\n\n/*Center Div*/\n\n.center-div {\n\tmargin: 0 auto;\n\twidth: 100%;\n\tjustify-content: center;\n}\n\n/* team */\n\n.team {\n\tbackground-color: #f7f7f7;\n\tmargin-top: 140px;\n\tmargin-bottom: -140px;\n\tpadding: 120px 0px;\n}\n\n.team-item img {\n\twidth: 100%;\n\toverflow: hidden;\n}\n\n.team-item .down-content {\n\tbackground-color: #fff;\n\tpadding: 30px;\n}\n\n.team-item .down-content h4 {\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tletter-spacing: 0.25px;\n\tmargin-bottom: 10px;\n}\n\n.team-item .down-content span {\n\tcolor: #03AC13;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tdisplay: block;\n\tmargin-bottom: 15px;\n}\n\n.team-item .down-content p {\n\tmargin-bottom: 20px;\n}\n\n\n/* Single Service */\n\n.single-services {\n\tmargin-top: 140px;\n}\n\n#tabs ul {\n  margin: 0;\n  padding: 0;\n}\n#tabs ul li {\n  margin-bottom: 10px;\n  display: inline-block;\n  width: 100%;\n}\n#tabs ul li:last-child {\n  margin-bottom: 0px;\n}\n#tabs ul li a {\n\ttext-transform: capitalize;\n\twidth: 100%;\n\tpadding: 20px;\n\tdisplay: inline-block;\n\tbackground-color: #1c7430;\n\tborder-radius: 25px;\n  \tfont-size: 18px;\n  \tcolor: #121212;\n  \tletter-spacing: 0.5px;\n  \tfont-weight: 700;\n  \ttransition: all 0.3s;\n}\n#tabs ul li a i {\n\tfloat: right;\n\tmargin-top: 5px;\n}\n#tabs ul .ui-tabs-active span {\n  background: #03AC13;\n  border: #faf5b2;\n  line-height: 90px;\n  border-bottom: none;\n}\n#tabs ul .ui-tabs-active a {\n  color: #fff;\n}\n#tabs ul .ui-tabs-active span {\n  color: #1e1e1e;\n}\n.tabs-content {\n\tmargin-left: 30px;\n  text-align: left;\n  display: inline-block;\n  transition: all 0.3s;\n}\n.tabs-content img {\n\tmax-width: 100%;\n\toverflow: hidden;\n}\n.tabs-content h4 {\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tletter-spacing: 0.25px;\n\tmargin-bottom: 15px;\n\tmargin-top: 30px;\n}\n.tabs-content h4 a {\n\tcolor: inherit;\t\n}\n.tabs-content p {\n  font-size: 14px;\n  color: #7a7a7a;\n  margin-bottom: 0px;\n}\n\n.dropdown-item.active, \n.dropdown-item:active {\n\tbackground-color: #a4c639;\n}\n\n/* Contact Information */\n\n.contact-information {\n\tmargin-top: 140px;\n}\n\n.contact-information .contact-item {\n\tpadding: 60px 30px;\n\tbackground-color: #f7f7f7;\n\ttext-align: center;\n}\n\n.contact-information .contact-item i {\n\tcolor: #03AC13;\n\tfont-size: 48px;\n\tmargin-bottom: 40px;\n}\n\n.contact-information .contact-item h4 {\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tletter-spacing: 0.25px;\n\tmargin-bottom: 15px;\n}\n\n.contact-information .contact-item p {\n\tmargin-bottom: 20px;\n}\n\n.contact-information .contact-item a {\n\tfont-weight: 600;\n\tcolor: #1c7430;\n\tfont-size: 15px;\n}\n\n\n\n#offers {\n  padding-top: 120px;\n}\n\n#offers .section-heading {\n  margin-bottom: 70px;\n}\n\n#offers .section-heading h6 {\n  padding-left: 0px;\n}\n\n#offers .section-heading h6:before {\n  display: none;\n}\n\n#offers .heading-tabs {\n  text-align: center;\n}\n\n#offers .heading-tabs .main-dark-button {\n  text-align: right;\n}\n\n#offers #tabs ul {\n  padding: 0;\n}\n#offers #tabs ul li {\n  display: inline-block;\n  margin: 0px 15px;\n}\n#offers #tabs ul li:last-child {\n  margin-right: 0px;\n}\n#offers #tabs ul li:first-child {\n  margin-left: 0px;\n}\n#offers #tabs ul li a {\n  text-transform: capitalize;\n  width: 100%;\n  display: inline-block;\n  font-size: 15px;\n  color: #2a2a2a;\n  font-weight: 600;\n  transition: all 0.3s;\n  text-align: center;\n}\n\n#offers #tabs ul li a img {\n  display: block;\n  margin: 0 auto 15px auto;\n}\n#offers #tabs ul .ui-tabs-active a {\n  color: #fb5849;\n  position: relative;\n}\n#offers #tabs ul .ui-tabs-active span {\n  color: #1e1e1e;\n}\n#offers .tabs-content {\n  margin-top: 60px;\n  text-align: left;\n  display: inline-block;\n  transition: all 0.3s;\n}\n#offers .tabs-content .tab-item {\n  position: relative;\n  margin-bottom: 60px;\n}\n#offers .tabs-content img {\n  float: left;\n  width: 100px;\n  max-width: 100px;\n  margin-right: 20px;\n  border-radius: 5px;\n}\n#offers .tabs-content h4 {\n  padding-top: 10px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #2a2a2a;\n  margin-bottom: 10px;\n  margin-right: 100px;\n}\n\n#offers .tabs-content p {\n  margin-right: 100px;\n}\n\n#offers .tabs-content .left-list {\n  margin-right: 15px;\n}\n\n#offers .tabs-content .right-list {\n  margin-left: 15px;\n}\n\n#offers .tabs-content .price h6 {\n  position: absolute;\n  top: 15px;\n  right: 0;\n  width: 70px;\n  height: 70px;\n  background-color: #fb5849;\n  display: inline-block;\n  text-align: center;\n  line-height: 70px;\n  border-radius: 3px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #fff;\n}\n\n\n\n\n\n/* Responsive Style */\n@media (max-width: 768px) {\n\t.sub-header {\n\t\tdisplay: none;\n\t}\n\t.Modern-Slider .item h6 {\n\t  margin-bottom: 15px;\n\t  font-size: 18px;\n\t}\n\t.Modern-Slider .item h4 {\n\t  margin-bottom: 25px;\n\t  font-size: 28px;\n\t  line-height: 36px;\n\t  letter-spacing: 1px;\n\t}\n\t.Modern-Slider .item p {\n\t\tmax-width: 570px;\n\t\tline-height: 25px;\n\t\tmargin-bottom: 30px;\n\t}\n\t.Modern-Slider .NextArrow{\n\t  right:5px;\n\t}\n\t.Modern-Slider .PrevArrow {\n\t  left:5px;\n\t}\n\t.request-form {\n\t\ttext-align: center;\n\t}\n\t.request-form a.border-button {\n\t\tfloat: none;\n\t\tmargin-top: 30px;\n\t}\n\t.services .service-item {\n\t\tmargin-bottom: 30px;\n\t}\n\t.fun-facts .left-content {\n\t\tmargin-right: 0px;\n\t\tmargin-bottom: 30px;\n\t}\n\t.more-info .right-content  {\n\t\tpadding: 30px;\n\t}\n\tfooter {\n\t\tpadding: 80px 0px 20px 0px;\n\n\t}\n\tfooter .footer-item {\n\t\tborder-bottom: 1px solid #343434;\n\t\tmargin-bottom: 30px;\n\t\tpadding-bottom: 30px;\n\t}\n\tfooter .last-item {\n\t\tborder-bottom: none;\n\t}\n\t.about-info .right-content {\n\t\tmargin-right: 0px;\n\t\tmargin-bottom: 30px;\n\t}\n\t.team .team-item {\n\t\tmargin-bottom: 30px;\n\t}\n\t.tabs-content {\n\t\tmargin-left: 0px;\n\t\tmargin-top: 30px;\n\t}\n\t.contact-item {\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.filled-button2 {\n\t\tbackground-color: #00933F;\n\t\tcolor: #fff;\n\t\tborder: none;\n\t\tfont-size: 8px;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 700;\n\t\tborder-radius: 30px;\n\t\tdisplay: inline-block;\n\t\ttransition: all 0.3s;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\t\ttext-shadow: none;\n\t\tcursor: pointer;\n\t}\n\n\n}\n\n@media (max-width: 992px) {\n\t.navbar .navbar-brand {\n\t\tposition: relative;\n\t\tleft: 30px;\n\t\ttop: -20px;\n\t\tbottom:50px;\n\t\tpadding-top:40px\n}\n\t.navbar .navbar-brand {\n\t\twidth: auto;\n\t}\n\t.navbar:after {\n\t\tdisplay: none;\n\t}\n\t#navbarResponsive {\n\t    z-index: 99999;\n\t    position: absolute;\n\t    top: 80px;\n\t    left: 0;\n\t    width: 100%;\n\t    text-align: center;\n\t    background-color: #fff;\n\t    box-shadow: 0px 10px 10px rgba(0,0,0,0.1);\n\t}\n\t.navbar .navbar-nav .nav-item {\n\t\tborder-bottom: 1px solid #eee;\n\t}\n\t.navbar .navbar-nav .nav-item:last-child {\n\t\tborder-bottom: none;\n\t}\n\t.navbar .navbar-nav a.nav-link {\n\t\tpadding: 15px 0px;\n\t\tcolor: #1e1e1e!important;\n\t}\n\t.navbar .navbar-nav .nav-link:hover,\n\t.navbar .navbar-nav .active>.nav-link,\n\t.navbar .navbar-nav .nav-link.active,\n\t.navbar .navbar-nav .nav-link.show,\n\t.navbar .navbar-nav .show>.nav-link {\n\t\tcolor: #03AC13!important;\n\t\tborder-bottom: none!important;\n\t}\n\t.filled-button2 {\n\t\tbackground-color: #00933F;\n\t\tcolor: #fff;\n\t\tborder: none;\n\t\tfont-size: 8px;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 700;\n\t\tborder-radius: 30px;\n\t\tdisplay: inline-block;\n\t\ttransition: all 0.3s;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\t\ttext-shadow: none;\n\t\tcursor: pointer;\n\t}\n}\n\nh5 a { color: #03AC13; } \nh5 a:hover { color: inherit; } \n\n\n.product-rating {\n    line-height: 22px;\n}\n.product-rating i {\n    color: #fc0;\n    display: inline-block;\n    margin-right: 2px;\n    font-size: 14px;\n}\n@media screen and (max-width: 1199px) {\n    .product-rating {\n        margin-bottom: 5px;\n        font-size: 15px;\n    }\n}\n@media screen and (max-width: 767px) {\n    .product-rating i {\n        font-size: 13px;\n    }\n}\n.text-secondary {\n    color: #004975 !important;\n}\n.card-wrapper {\n    position: relative;\n    overflow: hidden;\n}\n.card-wrapper .card-img {\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n    transition: all 0.3s ease-out;\n}\n.card-wrapper .card-img img {\n    transition: all 0.3s ease-in-out;\n    border-radius: 0.25rem;\n    border-radius: 0.25rem;\n}\n.card-wrapper .card-body {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    visibility: hidden;\n    padding: 30px;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transform: translateX(-100%);\n    transition: 0.8s;\n    z-index: 11;\n}\n.card-wrapper:before {\n    content: \"\";\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    top: 0;\n    right: 100%;\n    z-index: 9;\n    transition: 0.8s;\n    background: #4dce62;\n    border-radius: 0.25rem;\n}\n.card-wrapper:hover:before {\n    right: 0;\n}\n.card-wrapper h3,\n.card-wrapper p {\n    color: #fff;\n}\n.card-wrapper .read-more {\n    color: #fff;\n}\n.card-wrapper .read-more:after {\n    color: #fff;\n}\n.card-wrapper:hover .card-body {\n    visibility: visible;\n    transform: translateX(0px);\n}\n.card-wrapper:hover .backgound-color {\n    right: 0;\n}\n.ti-shopping-cart:before {\n    content: \"\\e60d\";\n}\n.mb-2-6, .my-2-6 {\n    margin-bottom: 2.6rem;\n}\n.text-primary {\n    color: #00baee !important;\n}\n\n\n.hoverCollapse {\n\tborder-radius: 5px;\n\tcolor: #000;\n\t\n}\n\n.hoverCollapse:hover{\n\tcolor:#2f975c;\n\ttransition: 1s;\n}\n\n.tagCollapse {\n\tcolor :\"#03AC13\"\n}\n.tagCollapse:hover {\n\tcolor :\"#F8F9FA\"\n}\n\n\n@media screen and (max-width: 1199px) {\n    .text-mobile-center {\n        text-align: center;\n    }\n\n\t.reserver-mobile-center {\n        display: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\ttext-align: center;\n\n    }\n}\n@media screen and (max-width: 767px) {\n\t.text-mobile-center {\n        text-align: center;\n    }\n\n\t.reserver-mobile-center {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\ttext-align: center;\n\n    }\n\n\t.show-text{\n\t\tdisplay: none;\n\t}\n\n\t\n\t.mobile-height{\n\t\theight:500px;\n\t}\n\n\t.text-banner-btn-size {\n\t\tfont-size: 10px;\n\t}\n\n\t.title-banner-size-mobile {\n\t\tfont-size: 18px;\n\t\tcolor:#fff;\n\t\ttext-align: justify;\n\n\t}\n\n\n\n\t.btn-space {\n\t\tmargin-top: 8px;\n\t\tdisplay: inline-flex;\n\t}\n\n}\n\n.btn-space{\n}\n.text-banner-btn-size {\n\tfont-size: 17px;\n}\n\n\n.title-banner-size {\n\tfont-size: 40px;\n\tcolor:#fff;\n}\n\n\n\n.reserver-web-center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n\n}\n\n.size-title-banner {\n\tfont-size: 40px;\n\tcolor:#fff;\n}\n\n\n.img-banner {\n\tfilter: grayscale(20%);\n\topacity: 0.5;\n\tbackground-size: contain;\n\tmin-width: 100%;\n\tmin-height: 'auto';\n}\n\n\n/* Style de base pour le carousel */\n.carousel-container {\n\tposition: relative;\n\tmargin: auto;\n\toverflow: hidden;\n\theight: 100vh;\n\tmin-width: 100%;\n  }\n  \n  .carousel {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n  }\n  \n  .carousel-items {\n\tdisplay: flex;\n\ttransition: transform 0.5s ease;\n\twidth: 100%;\n  }\n  \n  .carousel-item {\n\tflex-shrink: 0;\n\twidth: 100%;\n\tposition: relative;\n\ttext-align: center;\n\topacity: 0; /* Masquer par défaut */\n\ttransition: opacity 1s ease-in-out;\n  }\n  \n  .carousel-item.active {\n\topacity: 1; /* Afficher l'élément actif */\n  }\n  \n  .carousel-item img {\n\twidth: 100%;\n\theight: 100vh; /* Ajustez la hauteur du carousel */\n\tobject-fit: cover;\n  }\n  \n  /* Texte sur l'image */\n\n  \n\n  \n  .button-group {\n\tmargin-top: 20px;\n  }\n  \n  .button-group .btn {\n\tbackground-color: #03AC13;\n\tcolor: white;\n\tpadding: 10px 20px;\n\tmargin: 5px;\n\ttext-decoration: none;\n\tborder-radius: 5px;\n  }\n  \n  .button-group .btn:hover {\n\tbackground-color: #02a611;\n  }\n  \n  /* Navigation des boutons */\n  .carousel-button {\n\tposition: absolute;\n\ttop: 50%;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tcolor: white;\n\tborder: none;\n\tfont-size: 2rem;\n\tpadding: 10px;\n\tcursor: pointer;\n\tz-index: 10;\n  }\n  \n  .carousel-button:hover {\n\tbackground-color: rgba(0, 0, 0, 0.8);\n  }\n  \n  .prev {\n\tleft: 10px;\n  }\n  \n  .next {\n\tright: 10px;\n  }\n  \n  /* Animation de transition pour les éléments actifs */\n  .carousel-item.active {\n\topacity: 1;\n\ttransition: opacity 1s ease;\n  }\n  \n  /* Masquer les éléments non actifs */\n  .carousel-item:not(.active) {\n\topacity: 0;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
